<!-- 只对日期进行操作的统一控件-->
<template>
  <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="innerVisible" :title="info.title" width="500px" append-to-body @close="cancel">
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form label-width="150px" label-position="left" @submit.native.prevent>
        <div class="el-form-item-wrapper">
          <el-form-item :label="info.label">
            <el-date-picker
              v-model="changeDate"
              type="date"
              style="width:251px;"
              value-format="yyyy-MM-dd"
              clearable
              :picker-options="pickerOptions"
            />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="confirm">{{ $t('FinanceManage.Confirm') }}</el-button>
      <el-button size="mini" @click="cancel">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { Assert } from '@/utils/validate'
import moment from 'moment'
import lang from '@/lang'

export default {
  name: 'ChangeDialog',
  components: { },
  props: {
    showPageDate: { type: Boolean, required: false }, // 是否使用上次选中时间
    pageDate: { type: Date, required: false },
    visible: { type: Boolean, required: true },
    disabledAfterToday: { type: Boolean, default: true }, // 大于今天的日期禁止选择
    info: { type: Object, default: () => {
      return { title: lang.t('Message.PleaseEnterTheApprovalDate'),
        label: lang.t('CargoMsg.Cargo_FinancialAudit') }
    } }
  },
  data() {
    return {
      confirmCallbackFunc: null,
      innerVisible: this.visible,
      changeDate: moment(new Date()).format('YYYY-MM-DD'),
      pickerOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  computed: {
  },
  watch: {
    accountDate() {

    }
  },
  created() {
    if (this.showPageDate) {
      this.changeDate = moment(new Date(this.pageDate)).format('YYYY-MM-DD')
    }
  },
  methods: {
    disabledDate(currDate) {
      if (this.disabledAfterToday) {
        const d = moment(currDate, 'YYYY-MM_DD')
        return d > new Date()
      }
      return false
    },
    cancel() {
      this.$emit('update:visible', false)
      this.$emit('returnDatePage', this.changeDate)
    },
    close() {
      this.$emit('returnDatePage', this.changeDate)
    },
    async confirm() {
      await Assert.isNotBlank(this.changeDate, this.$t('Message.PleaseSelect') + `${this.info.title}` + this.$t('Message.Cargo_Date'), 'warning')
      this.$emit('confirm', this.changeDate)
    }
  }
}
</script>

<style lang="scss">
</style>
